import React from "react";
import PageLayout from "../../layouts/PageLayout";
import { Box, Heading } from "../../components/elements";
import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet-async";

export default function Telegram() {
    return (
        <PageLayout>
          <Helmet>
            <title>Telegram Bots</title>
            <meta name="description" content="Our Telegram bots streamline blockchain interactions with user-friendly commands, They support token sales, swaps, contract info, and real-time updates." />
            <meta name="keywords" content="telegram bot, telegram app, bot, telegram mini-app" />
            <meta name="author" content="0xFactory" />

            {/* Open Graph (for Facebook, LinkedIn, etc.) */}
            <meta property="og:title" content="Telegram Bots" />
            <meta property="og:description" content="Our Telegram bots streamline blockchain interactions with user-friendly commands, They support token sales, swaps, contract info, and real-time updates." />
            <meta property="og:image" content="https://i.ibb.co/9kZCJV4d/bot.png" />
            <meta property="og:url" content="https://0xfactory.com/telegram" />
            <meta property="og:type" content="website" />

            {/* Twitter Card (for Twitter sharing) */}
            <meta name="twitter:title" content="Telegram Bots" />
            <meta name="twitter:description" content="Our Telegram bots streamline blockchain interactions with user-friendly commands, They support token sales, swaps, contract info, and real-time updates." />
            <meta name="twitter:image" content="https://i.ibb.co/9kZCJV4d/bot.png" />
            <meta name="twitter:card" content="telegram_bot" />
          </Helmet>
            <Container fluid>
                <Heading as="h2" className="mc-overview-title">Telegram Bots</Heading>
                    <Row xs={1} sm={2} xl={2}>
                            <Col xs={12} sm={8} xl={8}>
                                <div>
                                  Our Telegram bots streamline blockchain interactions with user-friendly commands, They support token sales, swaps, contract info, and real-time updates.
                                </div>
                                <br/>
                                <div>
                                  Built for speed and reliability, they connect users with DeFi tools instantly, Ideal for ICOs, airdrops, and crypto communities looking for automation.
                                </div>
                                <br />
                                <div className="text-center">
                                  <h2 style={{color: 'yellow'}}>"Powerful Telegram Bots to Boost Blockchain Projects"</h2>
                                </div>
                                <br/>
                                <div className="text-center">
                                    <h1>1- ICO Presale Bot</h1>
                                </div>
                                <br/>
                                <div><h5>Easily manage your ICO presale with our powerful Telegram bot.</h5></div>
                                <div><h5>Users can check token info, live price, and buy directly in chat.</h5></div>
                                <div><h5>Secure, fast, and fully automated for a smooth fundraising experience.</h5></div>
                                <br/>
                                <div><h4>Demo : <a href="https://t.me/zxfPresaleBot" target="_blank" rel="noreferrer">https://t.me/zxfPresaleBot</a></h4></div>
                                <br/>
                                <h4><h3>Price : $150</h3></h4>
                                <br/>
                                <div className="text-center">
                                <a href="https://t.me/mohamedmox" target="_blank" rel="noreferrer"><h3 style={{color: 'yellow'}}>Contact Us</h3></a>
                                </div>
                                <br/>
                            </Col>
                            <Col xs={12} sm={4} xl={4}>
                                <Box>
                                    <div className="text-center">
                                        <img src="images/bot.png" width={"100%"} alt="Social Image" />
                                    </div>
                                    <br/>
                                </Box>
                            </Col>
                    </Row>
                </Container>
        </PageLayout>
    )
}
